import { $getRoot, $isElementNode, $isTextNode, LexicalNode } from "lexical";

/**
 * Recursively traverses all nodes and marks TextNodesq as dirty.
 * This triggers transforms to run on each TextNode, useful after
 * setEditorState which doesn't run transforms.
 */
export function $markTextNodesDirty(): void {
  const markDirtyRecursive = (children: LexicalNode[]) => {
    for (const child of children) {
      if ($isTextNode(child)) {
        child.markDirty();
      } else if ($isElementNode(child)) {
        markDirtyRecursive(child.getChildren());
      }
    }
  };
  markDirtyRecursive($getRoot().getChildren());
}
